// Combined solution that fixes both scrolling and keyboard dismissal issues
document.addEventListener('DOMContentLoaded', function() {

  // PART 1: Fix touch scrolling for search results
  function setupTouchScrolling() {
    // Select the search results container
    const searchResults = document.querySelector('.header__search__results');


    if (!searchResults) {
      return;
    }

    // Log container dimensions and scroll properties

    let startY = 0;
    let startScrollTop = 0;
    let touchInProgress = false;

    // Handle touch start
    searchResults?.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
      startScrollTop = searchResults.scrollTop;
      touchInProgress = true;
    }, { passive: false });

    // Handle touch move
    searchResults?.addEventListener('touchmove', function(e) {
      if (!touchInProgress) {
        return;
      }

      const currentY = e.touches[0].clientY;
      const deltaY = startY - currentY;
      const prevScrollTop = searchResults.scrollTop;

      // Apply the scroll
      searchResults.scrollTop = startScrollTop + deltaY;

      // Detailed container scroll state

      // Prevent default only if we're scrolling within our container and it has scrollable content
      if (searchResults.scrollHeight > searchResults.clientHeight) {
        // Check if we're at the top or bottom of the scroll and still trying to scroll in that direction
        const isAtTop = searchResults.scrollTop <= 0;
        const isAtBottom = searchResults.scrollTop + searchResults.clientHeight >= searchResults.scrollHeight;

        // Only prevent default if we're not at the boundaries or we're trying to scroll "into" the container
        if (!(isAtTop && deltaY < 0) && !(isAtBottom && deltaY > 0)) {
        
          e.preventDefault();
        } else {
        }
      } else {
      }
    }, { passive: false });

    // Handle touch end
    searchResults?.addEventListener('touchend', function() {
      touchInProgress = false;
    }, { passive: true });

    // Handle touch cancel
    searchResults?.addEventListener('touchcancel', function() {
      touchInProgress = false;
    }, { passive: true });

    // Add CSS enhancements for touch behavior
    const style = document.createElement('style');
    style.textContent = `
      .header__search__results {
        -webkit-overflow-scrolling: touch;
        touch-action: pan-y;
      }

      .search__results__wrapper {
        -webkit-overflow-scrolling: touch;
      }
    `;
    document.head.appendChild(style);

  }

  // PART 2: Fix keyboard dismissal issue for predictive search
  function patchPredictiveSearch() {

    // Find all predictive search instances
    const searchInstances = document.querySelectorAll('predictive-search');

    if (!searchInstances.length) {
      console.warn('[SearchFix] No PredictiveSearch instances found on page');
      return;
    }

    // For each instance, modify its behavior
    searchInstances.forEach((searchInstance, index) => {

      // Keep track of important state
      let keyboardDismissing = false;
      let keepResultsOpen = false;
      let hasResults = false;

      // Get input element
      const searchInput = searchInstance.querySelector('[data-predictive-search-input]');
      const resultsContainer = searchInstance.querySelector('[data-predictive-search-results]');

      if (!searchInput || !resultsContainer) {
        console.warn(`[SearchFix] Required elements not found in instance #${index + 1}`);
        return;
      }

      // Add touch listeners to detect interaction with results
      resultsContainer?.addEventListener('touchstart', () => {
        keepResultsOpen = true;
      });

      // Add click listeners to detect interaction with results
      resultsContainer?.addEventListener('click', () => {
        keepResultsOpen = true;
      });

      // Override the focusout event on the entire search component
      searchInstance?.addEventListener('focusout', (event) => {

        // Check if we have search results displayed
        hasResults = searchInstance.getAttribute('results') === 'true';

        if (hasResults) {

          // Check if the user has interacted with results or if the keyboard is being dismissed
          if (keepResultsOpen || keyboardDismissing) {
            event.stopPropagation();
            return false;
          }

          // Check if the event related target is within the search results
          // This handles the case where user taps on an item in the results
          if (event.relatedTarget && resultsContainer.contains(event.relatedTarget)) {
            event.stopPropagation();
            return false;
          }
        }
      }, true); // Use capture phase to intercept before component's handler

      // Detect keyboard dismissal through blur event on input
      searchInput?.addEventListener('blur', (event) => {

        // Check if we have search results displayed
        hasResults = searchInstance.getAttribute('results') === 'true';

        if (hasResults) {
         
          keyboardDismissing = true;

          // If the blur is due to clicking on a search result, keep results open
          if (event.relatedTarget && resultsContainer.contains(event.relatedTarget)) {
           
            keepResultsOpen = true;
          }

          // Reset the flags after a short delay
          setTimeout(() => {
        

            // If the user hasn't interacted with the results, allow closing
            if (!keepResultsOpen) {
    
              // Try to access the close method if it exists
              if (searchInstance.close && typeof searchInstance.close === 'function') {
                searchInstance.close();
              } else {
                // Alternative approach: manually remove open attributes
                searchInstance.removeAttribute('open');
                searchInstance.removeAttribute('results');
                if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
              }
            } else {
           
              // Reset the interaction flag for next interaction
              keepResultsOpen = false;
            }

            // Reset keyboard dismissal flag
            keyboardDismissing = false;
          }, 300);
        }
      });

      // Add special handling for the Done button on iOS keyboard
      // This is detected by monitoring the window resize event that occurs when keyboard shows/hides
      let windowHeight = window.innerHeight;
      let keyboardVisible = false;

      window.addEventListener('resize', () => {
        // If window height increases, keyboard is probably being hidden
        const newHeight = window.innerHeight;

        if (newHeight > windowHeight && keyboardVisible) {
          keyboardVisible = false;

          // If we have results and search input is not focused, this is likely a "Done" button press
          if (hasResults && document.activeElement !== searchInput) {
            keyboardDismissing = true;

            // Check after a delay if user interacted with results
            setTimeout(() => {
              if (!keepResultsOpen) {
                if (searchInstance.close && typeof searchInstance.close === 'function') {
                  searchInstance.close();
                }
              } else {
                keepResultsOpen = false;
              }
              keyboardDismissing = false;
            }, 500);
          }
        } else if (newHeight < windowHeight) {
          // Keyboard is likely being shown
          keyboardVisible = true;
        }

        // Update the height for next comparison
        windowHeight = newHeight;
      });
    });

  }

  // Run both fixes
  setupTouchScrolling();
  patchPredictiveSearch();

  // Also try again when the page is fully loaded (in case components initialize later)
  window.addEventListener('load', () => {
    setTimeout(() => {
      setupTouchScrolling();
      patchPredictiveSearch();
    }, 500);
  });
});